module.exports = __webpack_public_path__ + "img/Tags.636ab6ca.svg";